import { Injectable } from '@angular/core';
import svg2pdf from 'svg2pdf.js';

@Injectable({
  providedIn: 'root'
})
export class PDFService {
    svgText: any;
    constructor() {
        this.svgText = this.loadSvg('assets/logo.svg');
    }


    loadSvg(url) {
        const request = new XMLHttpRequest();
        request.open('GET', url, false);
        request.overrideMimeType('text/plain; charset=x-user-defined');
        request.send();
        
        if (request.status !== 200) {
            throw new Error(`Unable to fetch ${url}, status code: ${request.status}`);
        }
        
        return request.responseText;
        
    }

    
    addPage(pdf: any, clientName: string, dateTime: string, programDashboard: string){
        pdf.addPage('p','pt', 'letter');
        this.writeHeader(pdf, clientName, dateTime, programDashboard);
        this.writeFooter(pdf);
        pdf.setTextColor(255, 255, 255);
    }

    //Page Header
    writeHeader(pdf: any, clientName: string, dateTime: string, programDashboard: string){
        const width = pdf.internal.pageSize.width;   
        const parser = new DOMParser();
        const svgElement = parser.parseFromString(this.svgText, "image/svg+xml").getElementsByTagName('svg')[0];

        pdf.setLineWidth(58);  
        //pdf.setDrawColor(0,45,86);
        pdf.setDrawColor(52, 60, 72);
        pdf.line(24, 52, width - 24, 52);     

        pdf.setTextColor(255, 255, 255);
        
        this.convertSvgToPdf(svgElement, pdf, {      
        xOffset:  36,
        yOffset:  37,
        scale: 6/7,
        });

        pdf.setFont("verdana");
        pdf.setFontSize(10);
        pdf.setFontType("bold");

        let xOffset = this.getCenteredXOffset(pdf, clientName.toUpperCase()); 
        pdf.text(clientName.toUpperCase(), xOffset, 48);

        //var programDashboard: string = "Cumulative Summary";
        xOffset = this.getCenteredXOffset(pdf, programDashboard); 
        pdf.text(programDashboard, xOffset, 66);

        pdf.setFontSize(10);
        pdf.text(dateTime, width - (dateTime.length/2 + 133), 57);

    }



    writeFooter(pdf: any){
        const width = pdf.internal.pageSize.width;
        const height = pdf.internal.pageSize.height;
        const footerNote: string = 'Copyright '+ '©' + ' 2008-2019 Data Recognition Corporation.';

        pdf.setFont("Helvetica");
        pdf.setFontType('normal');
        pdf.setTextColor(107, 107, 107);
        pdf.setFontSize(9);
        const xOffset = this.getCenteredXOffset(pdf, footerNote); //Center align
        pdf.text(footerNote, xOffset, height - 15);

        pdf.text(pdf.internal.getNumberOfPages()+'', width - 28, height - 15);

        pdf.setTextColor(255, 255, 255);

    }

    writeHeaderAndFooter=(pdf: any, clientName: string, dateString: string, chartName: string, programDashboard: string)=>{
        this.writeHeader(pdf, clientName, dateString, programDashboard);
        this.writeFooter(pdf);
        pdf.setFont('verdana');
        pdf.setTextColor(88, 88, 88);
        pdf.setFontSize(14);
        pdf.text(chartName + ' - Tabular Data', 24, 110);  
    }

    getCenteredXOffset(pdf: any, text: string){
        return (pdf.internal.pageSize.width / 2) - (pdf.getStringUnitWidth(text) * pdf.internal.getFontSize() / 2);
    }

    drawfullWidthRectangle=(pdf)=>{
        const width = pdf.internal.pageSize.width;
        this.drawRectangle(pdf, 24, 130, width - 48, 325);
    }

    drawLine(pdf: any, startX: number, startY: number, endX: number, endY: number){  
        this.setDrawColor(pdf);    
        pdf.line(startX, startY, endX, endY);
    }
    
    drawRectangle(pdf: any, x: number, y: number, width: number, height: number){
        this.setDrawColor(pdf);   
        pdf.roundedRect(x, y, width, height, 3, 3, 'FD');
    }

    setDrawColor(pdf: any){
        pdf.setDrawColor(0, 0, 0, 0.3);
        pdf.setLineWidth(0.6);
    }

    writeTableOnlyTopdf=(pdf: any, chartData: any, chartName: string, clientName: string, dateString: string, programDashboard: string, addPage = true)=>{
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return new Promise((resolve, reject)=>{ 
            if(addPage){
                this.addPage(pdf, clientName, dateString, programDashboard);
            }
           
            pdf.setFont('verdana');
            pdf.setTextColor(88, 88, 88);
          
            const tableData: any = []
            chartData.forEach((row: any[], rowIndex: number)=>{
                tableData[rowIndex] = [];
                row.forEach((col: any, colIndex)=>{
                tableData[rowIndex][colIndex] = col;
                });
            });
            const columns = tableData[0];
            tableData.splice(0,1);
            const styles : any = {
                0:{fontStyle: 'normal',halign: 'left', fontSize: 8}
            };      
            //tableData.sort(this.sortFunction);
            this.addTableForCharts(pdf, columns, tableData, 126, 24, styles, clientName, dateString, chartName, programDashboard);
            resolve('done');
        });
    }

    addTableForCharts=(pdf: any, columns: string[], data: any[], top: number, left: number, columnStyles: any = {}, clientName, dateString, chartName, programDashboard: string)=>{    
        pdf.autoTable(columns, data, {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          addPageContent : (data)=>{
            this.writeHeaderAndFooter(pdf, clientName, dateString, chartName, programDashboard);
          },
          styles: {  
            cellPadding: 2,  
            cellSpacing: 1,      
            fontSize: 8,
            font: "helvetica",
            tableLineColor: 163,
            tableLineWidth: 3,
            fontStyle: 'normal', // normal, bold, italic, bolditalic         
            overflow: 'linebreak', // visible, hidden, ellipsize or linebreak
            fillColor: false, // false for transparent or a color as described below
            textColor:'#585858',
            halign: 'right', // left, center, right
            valign: 'middle', // top, middle, bottom
            columnWidth: 'wrap', // 'auto', 'wrap' or a num},
            lineWidth: 1,
            lineColor: 0,
            fillStyle: 'DF',    
            tableWidth: (pdf.internal.pageSize.width/2)-30
          },   
          columnStyles: columnStyles,   
          theme: 'grid',
          headerStyles: {halign: 'left', fillColor: false,fontStyle: 'bold'},
          bodyStyles: {fillColor: false,  textColor:'#585858', font: "helvetica"},
          alternateRowStyles: {fillColor: false},
          margin: {top: top, left: left},
          //tableWidth: (pdf.internal.pageSize.width/2)-30,
          tableLineColor: 163,
          tableLineWidth: 3      
        });
    }

    
  formatNumber(x) {
    if(isNaN(x) || !x){
      return x;
    }else{
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    
  }

  protected convertSvgToPdf(svgElement: SVGSVGElement, pdf: any, options: any): void {
    svg2pdf(svgElement, pdf, options);
  }

}